import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IKpiRepository } from '@/coreInfrastructureModule/interfaces/IKpiRepository';
import { Kpi } from '../domains/entities/Kpi';
/**
 * Kpi情報をPostする
 */
export class PostKpiUseCase {
  private repository: IKpiRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IKpiRepository) {
    this.repository = repository;
  }

  /**
   * KPI配列をAPIリクエスト形式に変換して保存する
   * @param request - 保存対象のKPI配列
   * @returns 保存結果
   */
  public async execute(request: Kpi[]): Promise<INetworkResult<undefined, IError>> {
    const convertMetricTypes = 'TURNOVER';
    const networkResult = await this.repository.post({
      metricType: convertMetricTypes,
      kpis: request.map((r) => ({
        kpiValue: r.kpiValue.toString(),
        dimensions: r.dimensions.map((d) => ({ dimensionType: d.dimensionType, dimensionValue: d.dimensionValue })),
      })),
    });
    switch (networkResult.status.type) {
      case 'success':
        return { status: { type: 'success', data: undefined } };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
